module.exports = __webpack_public_path__ + "img/pluto138.86e07831.jpg";